// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ReactController from "./react_controller"
application.register("react", ReactController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
